// 导入自有语言包
// CCUI统一标准语言标识
// ar 阿拉伯语（暂定）
// en-gb 英语
// fr-fr 法语
// es-es 西班牙语
// ru-ru 俄语
// zh-cn 中文
import zhCN from "./locale/zh-CN";
import enUS from "./locale/en-US";
import albAR from "./locale/ar";
import faFR from "./locale/fr";
import esEs from "./locale/es";
import elsRU from "./locale/ru-RU";
import enLocale from 'ccui/lib/locale/lang/en';
import zhLocale from 'ccui/lib/locale/lang/zh-CN';
import esLocale from 'ccui/lib/locale/lang/es';
import frLocale from 'ccui/lib/locale/lang/fr';
import ruLocale from 'ccui/lib/locale/lang/ru-RU';
import arLocale from 'ccui/lib/locale/lang/ar';
// 导入布局语言包
import layoutLocale from "./locale/layoutLocaleI18n";
console.log(enLocale, 'enLocale');

// 合并语言包
export default {
    "zh-cn": Object.assign(enUS, layoutLocale["en-US"], enLocale), // 中文
    "en-gb": Object.assign(enUS, layoutLocale["en-US"], enLocale), //英语
    "es-es": Object.assign(esEs, layoutLocale["es-ES"], esLocale), // 西班牙语
    "fr-fr": Object.assign(faFR, layoutLocale["fa-FR"], frLocale), // 法语
    "ru-ru": Object.assign(elsRU, layoutLocale["els-RU"], ruLocale), // 俄语
    ar: Object.assign(albAR, layoutLocale["alb-AR"], arLocale) // 阿拉伯语
};